export default __webpack_public_path__ + "static/media/Extension02.3743dd9c.png";